import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../state-management/action-creators';
import ErrorScreen from './../error-screen';
import * as nativeWebviewInterface from '@ifit/native-webview-interface';
import { showToast } from '../../util/show-toast';
import { Text } from './text';
import { GlobalText } from '../../i18n/global-text';
import { WebviewError } from '../../types';

interface IProps {
  setWebviewError: ({ from, stack }: WebviewError) => void;
  setWebviewErrorMsg: (value: string) => { type: string; value: string };
  children: React.ReactNode;
}

interface IState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): IState {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, info): void {
    const { setWebviewError, setWebviewErrorMsg } = this.props;

    showToast(error);
    setWebviewErrorMsg('Error caught in React Error Boundary');
    setWebviewError({
      from: 'ErrorBoundary',
      stack: info.componentStack,
    });
  }

  handleErrorClose = (): void => {
    const { setWebviewError, setWebviewErrorMsg } = this.props;
    setWebviewError(null);
    setWebviewErrorMsg(null);
    this.setState({ hasError: false });
    nativeWebviewInterface.callNative({
      methodName: 'RequestInitialization',
    });
  };

  render(): React.ReactNode {
    return this.state.hasError ? (
      <ErrorScreen buttonText={GlobalText.tryAgain} errorText={Text.errorText} handleClose={this.handleErrorClose} />
    ) : (
      this.props.children
    );
  }
}

export function mapDispatchToProps(): {
  setWebviewError: (value: WebviewError) => void;
  setWebviewErrorMsg: (value: string) => { type: string; value: string };
} {
  const { setWebviewError, setWebviewErrorMsg } = actions;
  return { setWebviewError, setWebviewErrorMsg };
}

export default connect(null, mapDispatchToProps())(ErrorBoundary);
